import ElementBound from '../core/ElementBound';
import { parseDom } from 'larasnap';

export default class extends ElementBound {
    _delay = 100;

    constructor(element) {
        super(element);

        this._button = element;

        // We need to create an inner wrapper which will be used to toggle between visibilities
        // while the outer element maintains the original width of the content when it is visible

        this._content = $(
            `.show-more-content[data-id="${element.data('id')}"]`,
        );
        const width = this._content.width();

        this._content.html(
            `<div class="show-more-content-inner">${this._content.html()}</div>`,
        );

        this._container = this._content;
        this._content = this._container.find('.show-more-content-inner');
        this._container.width(width);
        this._content.hide();

        element.html(element.data('more'));
        element.click(this.toggle.bind(this));
    }

    toggle() {
        const button = this._button;

        if (button.html() === button.data('more')) {
            this._content.show(this._delay, () => {
                parseDom();
            });
            button.html(button.data('less'));
        } else {
            this._content.hide(this._delay);
            button.html(button.data('more'));
        }
    }
}
